export const workexperiences = [
  {
    title: "Frontend Engineer",
    btn: "Full time",
    company: "Salesplat Technologies",
    location: "Hybrid",
    date: "Jun 2024 - Oct 2025",
  },

  {
    title: "Frontend Developer",
    btn: "Internship",
    company: "Code Garage Africa",
    location: "Remote",
    date: "Jan - Feb 2024",
  },

  {
    title: "Frontend Developer",
    btn: "Mentorship",
    company: "Techlift Community",
    location: "Remote",
    date: "May - July 2023",
  },
];
